import { Box, Grid, TextField, Typography } from '@mui/material'
import React, { } from 'react'
import RadioBoxGroup from '../../components/RadioButtons/RadioBoxGroup'
import CustomDepartmentSelect from './CustomDepartmentSelect'
import ToggleSwitch from '../../components/ToggleSwitch/ToggleSwitch';
import MyDatePicker from '../../components/Date-range-picker/MyDatePicker';
import PayRateHistory from './PayBillTable/PayRateHistory';
const labelStyle = {
  marginBottom: '4px',
  fontWeight: 600,
  color: '#1A1A1A',
  fontSize: '14px',
};

const inputStyle = {
  height: '46px',
  backgroundColor: '#fff',
  fontSize: '13px',
};

const PayBill = () => {
  const payPeriodOptions = [
    'None', 'Weekly', 'Twice per month', 'Bi-weekly', 'Monthly'
  ]
  const payRateOptions = [
    'Weekly', 'Hourly', 'Fixed',
  ]
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
        <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1A1F36', }}>Payment Rates</Typography>
        <RadioBoxGroup
          options={['Pay Rate', 'Bill Rate']}
          defaultValue="Pay Rate"
          row={true}
        /></Box>

      <Box mt={2}>
        <Typography variant="body2" sx={labelStyle}>
          Pay Period
        </Typography>
        <CustomDepartmentSelect selectedPlaceholder="Select Pay Period" modalSearchplaceHolder="Search Pay Period" initialOptions={payPeriodOptions} showAddOption={false} />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 2 }}>
        <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1A1F36', }}>Require timesheet approval</Typography> <ToggleSwitch />
      </Box>
      <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>

        <Grid item size={{ xs: 12, md: 7 }}>
          <Typography variant="body2" sx={labelStyle}>
            Pay rate
          </Typography>
          <Grid container spacing={1} alignItems="center">

            <Grid item size={{ xs: 12, md: 6, sm: 6 }}>
              <TextField
                fullWidth
                placeholder="0.0"
                variant="outlined"
                type="number"
                inputProps={{
                  step: "any"
                }}
                InputProps={{
                  sx: {
                    ...inputStyle,
                    // Remove arrows in Chrome, Safari, Edge
                    '& input[type=number]::-webkit-outer-spin-button': {
                      WebkitAppearance: 'none',
                      margin: 0,
                    },
                    '& input[type=number]::-webkit-inner-spin-button': {
                      WebkitAppearance: 'none',
                      margin: 0,
                    },
                    // Remove arrows in Firefox
                    '& input[type=number]': {
                      MozAppearance: 'textfield',
                    },
                  }
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 6, sm: 6 }}> <CustomDepartmentSelect selectedPlaceholder="Select  Pay rate" modalSearchplaceHolder="Search Pay rate" initialOptions={payRateOptions} showAddOption={false} searchBox={false} /></Grid>
          </Grid>
        </Grid>
        <Grid item size={{ xs: 12, md: 5, sm: 12 }}>
          <Typography variant="body2" sx={labelStyle}>
            Effective Date
          </Typography>
          <MyDatePicker />
        </Grid>
      </Grid>
      <PayRateHistory />
    </>
  )
}

export default PayBill
